/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_CancelledInputs */



/**
* | output |
* | --- |
* | "OCR processing cancelled." |
*
* @param {Ocr_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_cancelled = /** @type {((inputs?: Ocr_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement OCR annulé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Verarbeitung abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione OCR annullata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка OCR отменена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se canceló el procesamiento OCR.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR处理已取消。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCR処理はキャンセルされました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर प्रोसेसिंग रद्द कर दी गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processamento de OCR cancelado.")
	return /** @type {LocalizedString} */ ("OCR processing cancelled.")
});